function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.33 3.83L6.968 0l2.458 1.447-6.606 3.8z",
  transform: "translate(.021)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.465 2.09l2.851 1.6L6.742 7.5 3.88 5.867z",
  transform: "translate(.248 .133)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.545 4.5v7.457L7.13 15.67V8.234z",
  transform: "translate(.455 .287)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.628 6.606v1.862l-1.2-.617V5.9L0 4.5v7.457l6.415 3.713V8.234z",
  transform: "translate(0 .287)"
});

var SvgPackageIcon = function SvgPackageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15.957,
    viewBox: "0 0 14 15.957",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPackageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/package-icon.321a71db.svg";
export { ForwardRef as ReactComponent };